import { withSvgIcon } from './withSvgIcon';

export const ExclamationIcon = withSvgIcon(
  <>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9788 6.5C10.8033 6.5 10.6653 6.65001 10.6799 6.82491L11.1986 13.0494C11.2115 13.2049 11.3415 13.3245 11.4975 13.3245H12.515C12.6711 13.3245 12.801 13.2049 12.814 13.0494L13.3327 6.82491C13.3473 6.65001 13.2093 6.5 13.0338 6.5H10.9788ZM11.9949 17.5C12.7486 17.5 13.3597 16.8889 13.3597 16.1352C13.3597 15.3814 12.7486 14.7703 11.9949 14.7703C11.2411 14.7703 10.63 15.3814 10.63 16.1352C10.63 16.8889 11.2411 17.5 11.9949 17.5Z"
      fill="currentColor"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
